import React, { Component } from 'react';
import { Link } from 'react-router';
import './NotFound.css';

export default class NotFound extends Component {
  render() {
    return(
      <div className="NotFound">
        <div className="boo-wrapper">
          <div className="boo">
            <div className="face"></div>
          </div>
          <div className="shadow"></div>

          <h1>Oppsss!</h1>
          <p>
            Você não vai encontrar nada aqui
            <br />
            <Link to="/">Clique aqui pra voltar</Link>
          </p>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Views/NotFound/index.js